export enum Environment {
    local = 0,
    alpha = 5,
    dev = 10,
    training = 15,
    prod = 20,
    dr = 40,
    import = 60,
    test = 80,
    feature = 100
}
